<script setup lang="ts">
import { PageMeta } from '@/@vxapp/@Enums/PageMeta'
import BankingAccountsWorkspace from '@/views/Banking/Accounts/BankingAccountsWorkspace.vue'

definePage({
  meta: { ...PageMeta.Banking.Accounts.Meta, pageTitle: PageMeta.Banking.Accounts.Title },
})
</script>

<template>
  <BankingAccountsWorkspace />
</template>
